import { useLogger } from "@agportal/logger";
import { createRestClient } from "@dmvs/client";
import { strict as assert } from "assert";
import { isEmpty } from "lodash-es";

export default class OdstavkySluzebService {
    constructor(url) {
        assert(url, "url has to be specified");

        this.logger = useLogger();
        this.rest = createRestClient({
            baseURL: url,
        });
    }

    async ctiStavOdstavkySluzby(sluzba) {
        if (!isEmpty(sluzba)) {
            const { data } = await this.rest.get(`/by-sluzba/${sluzba}`);

            this.logger.debug("OdstavkySluzebService.ctiStavOdstavkySluzby for sluzba {0} returns {1}", sluzba, data);

            return data;
        }

        return null;
    }
}
